import { Component } from "@angular/core";
import { ContactPopupAbstractComponent } from "app/module/sharedModules/shared/modals/contact-popup-abstract/contact-popup-abstract.component";

@Component({
  selector: "app-contact-form-popup",
  templateUrl:
    "../contact-popup-abstract/contact-popup-abstract.component.html",
  styleUrls: ["./contact-form-popup.component.scss"],
})
export class ContactFormPopupComponent extends ContactPopupAbstractComponent { }
